import React, { useEffect, useState } from "react";
import "./AddInterview.css";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router";
import { addbanner, getallvendors } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";
import addimg from "../../assets/image.png";

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Required";
  }
  return errors;
};

const Addbanner = () => {
  const [load, setload] = useState(false);
  const [open, setOpen] = useState(false);
  const [vendor, setvendor] = useState([]);
  const [err, seterr] = useState("");
  const [preview, setPreview] = useState();
  const [image, setImage] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    getvendor();
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      for: "",
    },
    validate,
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const getvendor = async () => {
    try {
      const response = await getallvendors();
      setload(false);
      setvendor(response.data.data);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await addbanner(values, image);
      navigate("/Banners");
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }

      setload(false);
    }
  };

  const handleupload = (e) => {
    if (e.target && e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImage(file);
      setPreview(URL.createObjectURL(e.target.files[0]));
    } else {
      console.log("No file selected");
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Add Banner</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Banner Title</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="name"
              type="text"
              placeholder="Banner Title"
              minLength={1}
              maxLength={200}
              //   value={data.name}
              className="Auth_input"
            />
            {formik.errors.name ? (
              <p className="invalid">{formik.errors.name} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Banner For</label>
            <br />
            <select
              onChange={formik.handleChange}
              name="for"
              className="Auth_input"
              value={formik.values.for}
              style={{ width: "94%" }}
            >
              <option value="">All</option>

              {vendor.map((i) => (
                <option value={i.id}>{i.fullname}</option>
              ))}
            </select>
            {formik.errors.for ? (
              <p className="invalid">{formik.errors.for} </p>
            ) : null}
          </div>

          <div>
            <label htmlFor="img">
              <p className="Auth_label">Banner Image</p>

              {preview ? (
                <img
                  src={preview}
                  alt="editprofile_image"
                  className="images_cate"
                />
              ) : (
                <>
                  <div className="addbox_image">
                    <img src={addimg} alt="add image" />
                  </div>
                </>
              )}
            </label>
            <input
              onChange={handleupload}
              id="img"
              name="img"
              type="file"
              className="Auth_input"
              style={{ display: "none" }}
            />
          </div>

          <div />
          <button className="term_button" type="Submit">
            {load ? "Adding..." : "Save"}
          </button>
        </form>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Addbanner;
